// extracted by mini-css-extract-plugin
export var heroImage = "_mf-1";
export var modal = "_mf-0";